/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesareas1Inputs */

const en_opportunitiesareas1 = /** @type {(inputs: Opportunitiesareas1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Areas to work`)
};

const de_opportunitiesareas1 = /** @type {(inputs: Opportunitiesareas1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebiete zum Bearbeiten`)
};

/**
* | output |
* | --- |
* | "Areas to work" |
*
* @param {Opportunitiesareas1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesareas1 = /** @type {((inputs?: Opportunitiesareas1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesareas1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesareas1(inputs)
	return de_opportunitiesareas1(inputs)
});
export { opportunitiesareas1 as "opportunitiesAreas" }